import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import Link from '../Link';
import LoginButton from '../LoginButton/LoginButton';
import {
  BlackOverlay,
  NavBottom,
  NavColumn,
  NavLinks,
  NavTitle,
  StyledLanguageSwitch,
  Wrapper,
} from './Navigation.styles';

const Navigation = ({ languageSwitch, navigation, navIsOpen, setNavIsOpen }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <BlackOverlay navIsOpen={navIsOpen} onClick={() => setNavIsOpen(false)} />
      <Wrapper navIsOpen={navIsOpen}>
        {navigation.map(navigationColumn => {
          const { id, mainTitle, navGroup } = navigationColumn;

          return (
            <NavColumn key={id}>
              <NavTitle>{mainTitle}</NavTitle>
              {navGroup && navGroup.length > 0 && (
                <NavLinks>
                  {navGroup.map(navigationGroupItem => {
                    const { id: navigationGroupItemId, ctaUrl, linkTitle } = navigationGroupItem;

                    if (!ctaUrl) {
                      return null;
                    }

                    return (
                      <li key={navigationGroupItemId}>
                        <Link href={ctaUrl.url} type={ctaUrl.type} onClick={() => setNavIsOpen(false)}>
                          {linkTitle}
                        </Link>
                      </li>
                    );
                  })}
                </NavLinks>
              )}
            </NavColumn>
          );
        })}
        <NavBottom>
          <div className="icons-grid-container">
            <Link href={`${t('footer.links.downloadIosApp.link')}`}>
              <img src="/images/icons/app-store.png" className="app-store-icon" />
            </Link>
            <Link href={`${t('footer.links.downloadAndroidApp.link')}`} className="android-link">
              <img src="/images/icons/google-play-store.png" className="google-store-icon" />
            </Link>
          </div>

          <div className="line-break" />

          <StyledLanguageSwitch languages={languageSwitch} useFullLabels />
          <LoginButton cta={`${t('general.login')}`} half />
        </NavBottom>
      </Wrapper>
    </>
  );
};

export default Navigation;
